export default "__VITE_ASSET__26576fff__"